<app-header></app-header>

<div class="share-location-container">
  <h2 class="title">SOS Link</h2>

  <div *ngIf="infoMessage" class="alert alert-info">
    {{ infoMessage }}
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <div *ngIf="isLoading && !errorMessage" class="alert alert-secondary">
    Getting your location...
  </div>
</div>

<app-footer></app-footer>
